export const LOGIN = 'hall/auth/LOGIN'
export const LOGIN_PERSIST = 'hall/auth/LOGIN_PERSIST'
export const USER_INFO = 'hall/auth/USER_INFO'
export const LOGOUT = 'hall/auth/LOGOUT'
export const VERIFY_TOKEN = 'hall/auth/VERIFY_TOKEN'
export const RESET_PASSWORD = 'hall/auth/RESET_PASSWORD'

export const USER_TYPE = {
  LEAD: 'lead',
  TOTEM: 'totem',
  ASSOCIATE: 'associate',
  DIRECTOR: 'director',
  RELATIVE: 'relative',
  RESPONSIBLE: 'responsible',
  MEMBER: 'member',
  COLLABORATOR: 'collaborator',
  BIOMETRY_MANAGER: 'biometry_manager',
  FINANCIAL: 'financial',
  MANAGER: 'manager',
  ADMINISTRATOR: 'administrator',
}

// Mirrors `users.constants.PermissionMode` on the backend. Drives whether a
// user's access is still gated by the legacy `user_type` hierarchy or by
// Django auth permissions/groups during the permissioning migration.
export const PERMISSION_MODE = {
  USER_TYPE: 'user_type',
  DJANGO: 'django',
}
